import { cn } from '@repo/tailwind-config/tailwind.functions'
import { Link } from 'react-router-dom'

export type LinkOptions = {
  variant?: 'default' | 'no-underline'
  rel?: string
  target?: string
}

type Props = {
  name: string
  href: string
  className?: string
  options?: LinkOptions
}

const TextLink = ({ name, href, className, options }: Props) => {
  const { variant = 'default', rel, target } = options || {}
  return (
    <Link
      to={href}
      rel={rel}
      target={target}
      className={cn('text-inherit text-blue', { underline: variant === 'default' }, className)}
    >
      {name}
    </Link>
  )
}

export default TextLink
